import { endpoints } from "../../services/endpoint.ts/endpoint";
import { RequestParam } from "../../utils/contact";
import { getData, postData, putData } from "../api/action";
import store from "../index";

export const GET_HOST = "GET_HOST";

export const getSosReport = async (payload) => {
  // console.log("getSosReport payload ["+JSON.stringify(payload)+"]");
  const response = await getData({
    url: `${endpoints.GET_SOSREPORT.url}?${RequestParam(payload)}`,
  });
  // console.log("getSosReport response JSON: ", JSON.stringify(response, null, 2));
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

export const getSosReportExcel = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_EXCEL.url}?pageNumber=0&pageSize=${payload.pageSize}`,
  });
  return response;
};

export const getExcelSummary = async (payload) => {
  const response = await postData(
    { url: `${endpoints.GET_EXCEL_SUMMARY.url}` },
    payload
  );
  return response;
};

export const updateSosReport = async (payload) => {
  const response = await putData(
    { url: `${endpoints.UPDATE_SOSREPORT.url}/${payload.id}` },
    payload
  );
  return response;
};

export const deleteSosReport = async (payload, username) => {
  const response = await postData(
    {
      url: `${endpoints.REMOVE_SOSREPORT.url}?username=${encodeURIComponent(username)}`
    },
    payload
  );
  return response;
};

export const getHost = async (payload) => {
  // console.log("getHost payload: ", JSON.stringify(payload, null, 2));
  try {
    const response = await getData({
      url: `${endpoints.GET_SOSREPORT_REPORT.url}?host=${payload.host}&username=${payload.username}&group_id=${payload.group_id}`,
    });
    // console.log("getHost response JSON: ", JSON.stringify(response, null, 2));
    // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 사용
    store.dispatch({
      type: GET_HOST,
      payload: { data: response },
    });
    return response;
  } catch (error) {
    console.error("Error fetching host data:", error);
  }
};
